﻿import { TabsApi, TabsOptions, TabsProps } from '@u1/fixers';
import { useU1Base } from './base';
import { allowedOptionsKeys } from './consts';
import { BaseOptions } from '../shared/types';
import { ComponentName } from '@u1/ui-library-mapper';

export const useU1Tabs = (baseOptions?: BaseOptions<TabsProps, TabsOptions>) => {
  return useU1Base(TabsApi, true, allowedOptionsKeys.tabs, ComponentName.TABS, baseOptions);
};
